import anay_prof_pic from "../images/anay-prof-pic.jpg";
import norse_prof_pic from "../images/norse-prof-pic.jpg";
import shreyan_prof_pic from "../images/shreyan-prof-pic.jpg";
import vihaan_prof_pic from "../images/vihaan-prof-pic.jpg";
import keshav_prof_pic from "../images/keshav-prof-pic.jpg";
import sophia_prof_pic from "../images/sophia-prof-pic.jpg";
import kevin_prof_pic from "../images/kevin-prof-pic.jpg";

var leaders_sections = [
    {
        "name": "Vihaan Paliwal",
        "role": "Leader",
        "shortdesc": "Vihaan is a senior at Flex Online. He is a USACO Platinum qualifier, 5x AIME qualifier, and 2x Canada/USA Mathcamp attendee. Outside of academics, you can often find him playing/watching sports (football, basketball, soccer) and watching movies.",
        "image": vihaan_prof_pic
    },
    {
        "name": "Keshav Karumbunathan", 
        "role": "Leader", 
        "shortdesc": "Keshav is a junior at Jesuit high school. He is a 2x qualifier for the USA Math Olympiad Summer Program (MOP) and a member of the MIT-PRIMES USA research track. You can often find him watching basketball and solving puzzles. ",
        "image": keshav_prof_pic
    },
    {
        "name": "Manuel Norse",
        "role": "Coach",
        "shortdesc": "Manuel Norse is a teacher at Willamette Valley Academy. He has been coaching math competitions including ARML and MathCounts for two decades, leading the Oregon ARML team to multiple top 20 finishes.",
        "image": norse_prof_pic
    },
    {
        "name": "Sophia Han",
        "role": "Problem Writer",
        "shortdesc": "Sophia is a sophomore from Lake Oswego High School. She qualified for USAJMO twice and attended MOP in 2026. Outside of math, she likes reading, writing, and playing violin.",
        "image": sophia_prof_pic
    },
    {
        "name": "Kevin Cheng",
        "role": "Problem Writer",
        "shortdesc": "Kevin is a sophomore at Jesuit High School. He is an advanced math student and a 3x AIME Qualifier. In his free time, Kevin enjoys playing tennis and solving puzzles.",
        "image": kevin_prof_pic
    }
]

var retired = [
    {
        "name": "Anay Aggarwal",
        "role": "Leader",
        "shortdesc": "'21-'26",
        "image": anay_prof_pic
    },
    {
        "name": "Shreyan Paliwal",
        "role": "Founder & Leader",
        "shortdesc": "'21 - '25",
        "image": shreyan_prof_pic
    }
]

export { leaders_sections, retired };
